import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { ApiWaveDecisionWinner } from "@/generated/models/ApiWaveDecisionWinner";
import { WaveWinnersLoading } from "./WaveWinnersLoading";
import { WaveWinnersEmpty } from "./WaveWinnersEmpty";
import { WaveWinnersPodiumContent } from "./WaveWinnersPodiumContent";
interface WaveWinnersPodiumProps {
  readonly onDropClick: (drop: ExtendedDrop) => void;
  readonly winners: ApiWaveDecisionWinner[];
  readonly isLoading: boolean;
}
export const WaveWinnersPodium: React.FC<WaveWinnersPodiumProps> = t0 => {
  const $ = _c(7);
  const {
    onDropClick,
    winners,
    isLoading
  } = t0;
  const firstPlaceWinner = winners[0];
  const secondPlaceWinner = winners[1];
  const thirdPlaceWinner = winners[2];
  if (isLoading) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <WaveWinnersLoading />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (!winners.length) {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <WaveWinnersEmpty />;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] !== firstPlaceWinner || $[3] !== onDropClick || $[4] !== secondPlaceWinner || $[5] !== thirdPlaceWinner) {
    t1 = <WaveWinnersPodiumContent onDropClick={onDropClick} firstPlaceWinner={firstPlaceWinner} secondPlaceWinner={secondPlaceWinner} thirdPlaceWinner={thirdPlaceWinner} />;
    $[2] = firstPlaceWinner;
    $[3] = onDropClick;
    $[4] = secondPlaceWinner;
    $[5] = thirdPlaceWinner;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
};